<template>
  
        <div class="banner">
            <img :src="imgUrl" alt="">
        </div>
   
</template>

<script>

export default {
    name: 'banner',
    props:['imgUrl'],
    components: {

    },
    data() {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
.banner{
    display: flex;
   
    align-items: center;
    justify-content: center;
    img{
        width: 90%;
    }
}
@media screen and (max-width: 767px) {
    .banner{
    
    img{
        width: 100% !important;
    }
}
   
   
}
</style>